export enum DataStatus {
    IDLE = 'idle',
    SUCCESS = 'success',
    FAILED = 'failed',
    LOADING = 'loading'
}
